export default {
  regular: 'Montserrat-Regular',
  bold: 'Montserrat-SemiBold',
  thin: 'Montserrat-ExtraLight',
};
